import { Tween } from "../Tween";
import GameEvents from "../../src/const/GameEvents";
import GameModel from "../../src/model/GameModel";
import { IWinData } from "../../src/server/data/ISpinData";
import App from "../App";
import SoundVars from "../const/SoundVars";
import BangUp from "../utils/BangUp";
import Layout from "../utils/Layout";
import SoundController from "../utils/SoundController";
import ViewManager from "../utils/ViewManager";
import BaseView from "./BaseView";
import { BitmapMoneyField } from "./BitmapMoneyField";
import SceneView from "./SceneView";
import { DefaultLayers } from "../utils/Layers";
import { Loader, Container, Point } from "pixi.js";
import ConsoleUtil from "../utils/ConsoleUtil";
import SpinModel from "../model/SpinModel";

export default class WinlinesView extends BaseView {
    protected symBounds: { width: number; height: number };
    protected contBounds: { width: number; height: number };
    protected paylinesScene: SceneView;
    protected winFrameContainer: Container;
    protected loader: Loader;
    protected celebrationsLayer: string;
    protected paylineLayer: string;
    protected reelHeight: number;
    public winValueBanner: BitmapMoneyField;
    public winValueBannerBangUp: BangUp;

    create(
        scene: SceneView,
        paylineLayer?: string,
        celebrationsLayer?: string,
        reelHeight?: number
    ) {
        this.winFrameContainer = new Container();
        this.celebrationsLayer = celebrationsLayer;
        this.paylineLayer = paylineLayer;
        this.symBounds = scene.positions.get("sym");
      
        this.reelHeight = isNaN(reelHeight)
            ? this.config.reelHeight || 3
            : reelHeight;
        let sceneName = "";
        if (scene.name.indexOf("-") != -1) {
            let splitName = scene.name.split("-");
            sceneName = splitName[splitName.length - 1];
        }
        this.paylinesScene = ViewManager.getLayer(
            paylineLayer || DefaultLayers.Paylines
        ).setScene(sceneName);
        // this.paylinesScene.addChild(this.winFrameContainer);
        this.winValueBannerBangUp = new BangUp();
        this.paylinesScene.forceLandscape();
        this.paylinesScene.addSubView(
            this.winFrameContainer,
            "winFrames",
            "lines"
        );

        // TODO if winFrameContainer uncoment end remove somehow for particle style lines
        // this.winFrameContainer.x = this.paylinesScene.containers.has("lines")
        //     ? Layout.scalePixels(
        //         scene.sceneBounds.x -
        //         Layout.getX(this.paylinesScene.containers.get("lines"))
        //     )
        //     : Layout.scalePixels(scene.sceneBounds.x);
        // this.winFrameContainer.y = this.paylinesScene.containers.has("lines")
        //     ? Layout.scalePixels(
        //         scene.sceneBounds.y -
        //         Layout.getY(this.paylinesScene.containers.get("lines"))
        //     )
        //     : Layout.scalePixels(scene.sceneBounds.y);
        this.contBounds = {
            width: this.paylinesScene.containers.has("lines")
                ? Layout.scalePixels(
                    Layout.getWidth(this.paylinesScene.containers.get("lines"))
                )
                : Layout.scalePixels(scene.sceneBounds.width),
            height: this.paylinesScene.containers.has("lines")
                ? Layout.scalePixels(
                    Layout.getHeight(this.paylinesScene.containers.get("lines"))
                )
                : Layout.scalePixels(scene.sceneBounds.height)
        };

        // console.log(this.winFrameContainer.x ,this.winFrameContainer.y,scene.sceneBounds,Layout.getX(this.paylinesScene.containers.get("lines")),Layout.getY(this.paylinesScene.containers.get("lines")))
        this.paylinesScene.onOrientationChange();
        // this.createWinValueBanner();
    }

    /**
     * @param removePrevious {Boolean} set false if you want old win lines to stay
     * @param winLineData {IWinData}
     */
    public highlightWinLine(winLineData: IWinData, removePrevious = true) {
        if (removePrevious) {
            this.winFrameContainer.removeChildren();
        }

        const winReels = winLineData.winReels;
        const winSyms = winLineData.winSymbols;
        // const cfg = App.config;
        const cfg = {
            symWidth: Layout.scalePixels(this.symBounds.width),
            symHeight: Layout.scalePixels(this.symBounds.height),
            reelGap: Layout.scalePixels(GameModel.gameConfig.reelGap),
            symGap: Layout.scalePixels(GameModel.gameConfig.symGap),
            frameLeft: Layout.scalePixels(GameModel.gameConfig.frameLeft),
            frameTop: Layout.scalePixels(GameModel.gameConfig.frameTop),
            frameBottom: Layout.scalePixels(GameModel.gameConfig.frameBottom),
            frameRight: Layout.scalePixels(GameModel.gameConfig.frameRight),
            beginningOffset: Layout.scalePixels(
                GameModel.gameConfig.beginningOffset
            ),
            winFrameConnectors: GameModel.gameConfig.winFrameConnectors,
            frameConnectorVerticalOffset: Layout.scalePixels(
                GameModel.gameConfig.frameConnectorVerticalOffset
            ),
        };

        // Win symbol frames
        if (!GameModel.gameConfig.noWinFrame) {
            for (let winIdx = 0; winIdx < winReels.length; winIdx++) {
                const reelIdx = winReels[winIdx];

                const ptTopLeft = new Point();
                ptTopLeft.x =
                    cfg.beginningOffset +
                    reelIdx * (cfg.symWidth + cfg.reelGap) -
                    cfg.frameLeft;
                ptTopLeft.y =
                    winSyms[winIdx] * (cfg.symHeight + cfg.symGap) -
                    cfg.frameTop;

                const ptBotLeft = new Point();
                ptBotLeft.x = ptTopLeft.x;
                ptBotLeft.y =
                    winSyms[winIdx] * (cfg.symHeight + cfg.symGap) +
                    cfg.symHeight +
                    cfg.frameBottom;

                const ptTopRight = new Point();
                ptTopRight.x =
                    cfg.beginningOffset +
                    reelIdx * (cfg.symWidth + cfg.reelGap) +
                    cfg.symWidth +
                    cfg.frameRight;
                ptTopRight.y = ptTopLeft.y;

                const ptBotRight = new Point();
                ptBotRight.x = ptTopRight.x;
                ptBotRight.y = ptBotLeft.y;

                this.drawLineSegment(ptBotRight, ptBotLeft, true);
                this.drawLineSegment(ptBotLeft, ptTopLeft, true);
                this.drawLineSegment(ptTopLeft, ptTopRight, true);
                this.drawLineSegment(ptTopRight, ptBotRight, true);
            }
        }

        if (winLineData.normalLineWin) {
            const lineId = winLineData.lineId;
            const lineSymPositions =
                GameModel.serverGameConfig.paylines[lineId];
            const numWinSyms = winLineData.winSymbols.length;
            const numLineSyms = lineSymPositions.length;

            if (cfg.winFrameConnectors == true) {
                // Segments connecting the frames
                for (let segIdx = 0; segIdx < numWinSyms - 1; segIdx++) {
                    const startY = lineSymPositions[segIdx];
                    const endY = lineSymPositions[segIdx + 1];

                    const startPt = new Point();
                    const endPt = new Point();

                    startPt.x =
                        cfg.beginningOffset +
                        (segIdx * (cfg.symWidth + cfg.reelGap) +
                            cfg.symWidth +
                            +cfg.frameRight);
                    endPt.x = startPt.x + (cfg.reelGap - cfg.frameLeft);

                    startPt.y =
                        lineSymPositions[segIdx] *
                            (cfg.symHeight + cfg.symGap) +
                        cfg.symHeight * 0.5;
                    endPt.y = startPt.y;

                    if (startY > endY) {
                        startPt.y -=
                            cfg.symHeight * 0.5 -
                            cfg.frameConnectorVerticalOffset;
                        endPt.y =
                            startPt.y -
                            (cfg.symGap - 2 * cfg.frameConnectorVerticalOffset);
                    } else if (startY < endY) {
                        startPt.y +=
                            cfg.symHeight * 0.5 -
                            cfg.frameConnectorVerticalOffset;
                        endPt.y =
                            startPt.y +
                            (cfg.symGap + 2 * cfg.frameConnectorVerticalOffset);
                    }

                    this.drawLineSegment(startPt, endPt, false);
                }
            }

            if (
                GameModel.gameConfig.noWinFrame ||
                (numWinSyms < numLineSyms && this.config.winLineTails)
            ) {
                let position = GameModel.gameConfig.noWinFrame
                    ? 0
                    : numWinSyms - 1;
                let endPosition = position + 1;
                let startPt = new Point();
                let endPt = new Point();
                while (position < numLineSyms - 1) {
                    const startY = lineSymPositions[position];
                    const endY = lineSymPositions[endPosition];
                    startPt.x =
                        cfg.beginningOffset +
                        (position * (cfg.symWidth + cfg.reelGap) +
                            cfg.symWidth *
                                (GameModel.gameConfig.noWinFrame ||
                                position > numWinSyms - 1
                                    ? 0.5
                                    : 1) +
                            cfg.frameRight);
                    endPt.x =
                        cfg.beginningOffset +
                        (endPosition * (cfg.symWidth + cfg.reelGap) +
                            cfg.symWidth * 0.5);

                    startPt.y =
                        lineSymPositions[position] *
                            (cfg.symHeight + cfg.symGap) +
                        cfg.symHeight * 0.5;
                    endPt.y =
                        lineSymPositions[endPosition] *
                            (cfg.symHeight + cfg.symGap) +
                        cfg.symHeight * 0.5;

                    this.drawLineSegment(startPt, endPt, true);

                    position++;
                    endPosition++;
                }

                // TAIL
                startPt = new Point();
                endPt = new Point();

                startPt.x =
                    cfg.beginningOffset +
                    ((numLineSyms - 1) * (cfg.symWidth + cfg.reelGap) +
                        cfg.symWidth * 0.5);
                endPt.x = startPt.x + (cfg.reelGap + cfg.symWidth * 0.5);

                startPt.y =
                    lineSymPositions[numLineSyms - 1] *
                        (cfg.symHeight + cfg.symGap) +
                    cfg.symHeight * 0.5;
                endPt.y = startPt.y;

                this.drawLineSegment(startPt, endPt, true);
            }
        }
    }

    public showLineValue(index: number, winValue: number) {
        const scene = ViewManager.getLayer(
            this.celebrationsLayer || DefaultLayers.PaylineCelebration
        ).setScene("line_row_" + (this.reelHeight + 1 - index)); // 4 because indexes are inversed and start from 1
        const moneyField = scene.sceneMoneyFields.get("value");
        moneyField.alpha = 0;
        Tween.to(moneyField, 0.2, { alpha: 1 });
        moneyField.value = winValue;
    }

    public drawLineSegment(
        startPt: Point,
        endPt: Point,
        addDot: boolean
    ) {
        const deltaX = endPt.x - startPt.x;
        const deltaY = endPt.y - startPt.y;
        const lineSegment = this.assets.getTilingSprite(
            "winline_overlaysHD/winline_segment",
            Math.sqrt(deltaX * deltaX + deltaY * deltaY),
            Layout.scalePixels(this.config.frameThickness)
        );
        // lineSegment.t
        lineSegment.anchor.set(0, 0.5);
        lineSegment.x = startPt.x;
        lineSegment.y = startPt.y;


        // lineSegment.width = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        // lineSegment.height = Layout.scalePixels(this.config.frameThickness);
        lineSegment.rotation = Math.atan2(deltaY, deltaX);
        Tween.from(lineSegment.scale, 0.15, {
            x: 0,
            y: 0,
            delay: startPt.x / 3000,
        });

        this.winFrameContainer.addChild(lineSegment);

        if (addDot) {
            const dot = this.assets.getSprite("winline_overlaysHD/dot");
            dot.anchor.set(0.5, this.config.winLineDotOffset || 0.5);
            dot.x = endPt.x;
            dot.y = endPt.y;
            dot.width = dot.height = Layout.scalePixels(
                this.config.frameThickness
            );

            this.winFrameContainer.addChild(dot);

            Tween.from(dot, 0.15, { alpha: 0, delay: dot.x / 3000 });
        }
    }

    public hideLines() {
        this.winFrameContainer.removeChildren();
        const celebrationScene = ViewManager.getLayer(
            this.celebrationsLayer || DefaultLayers.PaylineCelebration
        ).getCurrentScene();
        if (celebrationScene) {
            celebrationScene.destroy();
        }
    }

    // private createWinValueBanner() {
    //     const conf = new BitmapMoneyFieldConfig();
    //     conf.bounds.width = 600;
    //     conf.bounds.height = 100;
    //     conf.currencyFontSize = 80;
    //     conf.centsFontSize = 120;
    //     conf.moneyFontSize = 120;
    //     conf.align = "center";
    //     // conf.debug = true;
    //     conf.showIdentifier = false;
    //
    //     this.winValueBanner = new BitmapMoneyField(conf);
    //     Layout.testSetWidth(this.winValueBanner, this.winValueBanner.width);
    //     Layout.horizontalAlignCenter(this.winValueBanner);
    //     Layout.setY(this.winValueBanner, 600);
    //     this.winValueBanner.value = 123123123;
    //     // this.paylinesScene.addChild(this.winValueBanner);
    //     this.paylinesScene.addSubView(this.winValueBanner, "winFrames", "lines");
    //     this.winValueBanner.visible = false;
    //
    // }

    public setWinBannerValue(value: number, animate = false) {
        const layer = ViewManager.getLayer(DefaultLayers.PaylineCelebration);
        layer.clear();
        if (SpinModel.hasBigWin() && !SpinModel.respinsRunning) {
            this.playWinSound();
            this.emit(GameEvents.BANNER_ANIM_COMPLETE);
            return;
        }
        
        const scene = layer.setScene("totalWin");
        this.winValueBanner = scene.sceneMoneyFields.get(
            "value"
        ) as BitmapMoneyField;
        if (animate) {
            this.winValueBanner.value = 0;
            const wincountSound = SoundController.playSound(
                SoundVars.EFFECT_WINCOUNT
            );
            this.winValueBannerBangUp.startBangup(
                0,
                value,
                2,
                null,
                (currentVal) => {
                    this.winValueBanner.value = currentVal;
                },
                () => {
                    if (wincountSound) {
                        SoundController.stopSound(wincountSound);
                    }
                    
                    this.playWinSound();
                    this.emit(GameEvents.BANNER_ANIM_COMPLETE);
                }
            );
        } else {
            this.winValueBanner.value = value;
            this.playWinSound();
            this.emit(GameEvents.BANNER_ANIM_COMPLETE);
        }
        this.winValueBanner.visible = true;
    }

    public setGroupWinBannerValue(value: number, animate = false, x: number, y: number) {
        const layer = ViewManager.getLayer(DefaultLayers.PaylineCelebration);
        layer.clear();
        const scene = layer.setScene("line_row_1");
        this.winValueBanner = scene.sceneMoneyFields.get(
            "value"
        ) as BitmapMoneyField;
        ConsoleUtil.log(this.winValueBanner, "banner")
        this.winValueBanner.x = x + 200;
        this.winValueBanner.y = y - 150;
        if (animate) {
            this.winValueBanner.value = 0;
            const wincountSound = SoundController.playSound(
                SoundVars.EFFECT_WINCOUNT
            );
            this.winValueBannerBangUp.startBangup(
                0,
                value,
                2,
                null,
                (currentVal) => {
                    this.winValueBanner.value = currentVal;
                },
                () => {
                    if (wincountSound) {
                        SoundController.stopSound(wincountSound);
                    }
                    
                    this.playWinSound();
                    this.emit(GameEvents.BANNER_ANIM_COMPLETE);
                }
            );
        } else {
            this.winValueBanner.value = value;
            this.playWinSound();
            this.emit(GameEvents.BANNER_ANIM_COMPLETE);
        }
        this.winValueBanner.visible = true;
    }

    protected playWinSound () {
        SoundController.playSound(SoundVars.EFFECT_TAKEWIN);
    }

    get config() {
        return App.config;
    }
    get assets() {
        return App.assets;
    }
}
